











import { createComponent } from '@vue/composition-api'

export default createComponent({
  name: 'AppAlert',
  props: {
    alert: {
      type: Object
    },
    dismiss: {
      type: Function
    }
  }
})
